import { useCallback } from 'react';
import { useMemo } from 'react';
import { useState } from 'react';
import { Setter } from 'libs/end-to-end/src/ui-types';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { useAsyncEffect } from 'apps/sigma2-ui/src/lib/hooks/useAsyncEffect';
import { AdminOrganizations } from 'libs/end-to-end/src/admin';
import { Organizations } from 'libs/end-to-end/src/types/organizations/organizations';
import { useUser } from 'apps/sigma2-ui/src/state/user';
import { getApiBaseUrl } from 'apps/sigma2-ui/src/constants/environment';
import { ListItem } from 'libs/end-to-end/src/types/generic/generic';
import { useReadPattern } from 'apps/sigma2-ui/src/lib/hooks/useReadPattern';
import { useReadFn } from 'apps/sigma2-ui/src/lib/hooks/useReadFn';

export interface DatabasesPageHook {
  selectedOrganization: string | null;
  setSelectedOrganization: Setter<string | null>;
  organizations: ListItem<string>[];
  organizationSelectBoxLabel: string;
  welcomeText: string;
}

export const useDatabasesPage = (): DatabasesPageHook => {
  const language = useLanguage();
  const [selectedOrganization, setSelectedOrganization] = useState<
    string | null
  >(null);

  const readPatternGetUrlFn = useCallback(() => {
    return `${getApiBaseUrl()}/organizations`;
  }, []);

  const readPatternHook = useReadPattern(
    useReadFn({
      getUrlFn: readPatternGetUrlFn,
      canRead: true,
      responseSchema: Organizations,
    }),
  );

  return useMemo(() => {
    return {
      selectedOrganization,
      setSelectedOrganization,
      organizations:
        readPatternHook.status === 'done'
          ? readPatternHook.entity.organizations.map((org) => ({
              optionValue: org.id,
              optionLabel: org.name,
            }))
          : [],
      organizationSelectBoxLabel:
        language.databasesPageOrganizationSelectBoxLabel(),
      welcomeText: language.databasesPageWelcomeText(),
    };
  }, [selectedOrganization, readPatternHook, language]);
};
